<template>
    <ImagePlusIcon class="animate-upload-icon-pulse" />
</template>

<script setup lang="ts">
import { ImagePlusIcon } from '@lucide/vue';
</script>
